// src/store/store.ts
import { create } from 'zustand';
import Cookies from 'js-cookie';

interface User {
    nickname: string;
    name: string;
    firstName: string;
    lastName: string;
    avatar: {
        url: string;
    };
}

// Define the shape of your store
interface StoreState {
    postId: number | null;
    setPostId: (id: number) => void;

    authToken: string | null;
    user: User | null;
    initializeAuth: () => void;
    login: (token: string, userData: User) => void;
    logout: () => void;
}

// Create the Zustand store with typed state and actions
const useStore = create<StoreState>((set) => ({
    postId: null,
    setPostId: (id: number) => set({ postId: id }),

    authToken: null,
    user: null,
    initializeAuth: () => {
        const token = Cookies.get('authToken');
        const userData = Cookies.get('user');
        if (token && userData) {
            try {
                const parsedUser: User = JSON.parse(userData);
                set({
                    authToken: token,
                    user: parsedUser,
                });
            } catch (error) {
                console.error('Failed to parse user data from cookies', error);
                // Optionally, handle parsing errors, e.g., by clearing invalid cookies
            }
        }
    },
    login: (token: string, userData: User) => {
        Cookies.set('authToken', token);
        Cookies.set('user', JSON.stringify(userData));
        set({
            authToken: token,
            user: userData,
        });
    },
    logout: () => {
        Cookies.remove('authToken');
        Cookies.remove('user');
        set({
            authToken: null,
            user: null,
        });
    },
}));

export default useStore;
